import { SideMenu, SideMenuGroup, SideMenuItem } from '@plaidev/sour-react';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useAccount } from 'auth-lib-front';
import type { Dispatch, SetStateAction } from 'react';
import type {} from 'react/jsx-runtime';

type MenuItem = {
  name: string;
  path: string;
  pathMatch: RegExp;
  systemAdminOnly?: boolean;
};

const menuItems = [
  {
    name: 'ソースシステム',
    path: '/settings/source-systems',
    pathMatch: /\/settings\/source-systems(\/.*|$)/,
  },
  {
    name: '管理者設定',
    path: '/settings/admin-settings',
    pathMatch: /\/settings\/admin-settings(\/.*|$)/,
    systemAdminOnly: true,
  },
] as const satisfies MenuItem[];

const isSystemAdminOnlyItem = (item: MenuItem) => item.systemAdminOnly === true;

type SettingsMenuProps = {
  width: number;
  setWidth: Dispatch<SetStateAction<number>>;
};

export const SettingsMenu = ({ width, setWidth }: SettingsMenuProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { account } = useAccount();

  // systemAdminOnly 項目の表示可否は社内メンバー権限 (isEmployee) に紐づく（auth-lib-front の規約に合わせる）
  const visibleItems = menuItems.filter((item) => !isSystemAdminOnlyItem(item) || account.isEmployee);

  return (
    <SideMenu title="設定" width={width} onPanelWidthChange={setWidth}>
      <SideMenuGroup>
        {visibleItems.map((item) => (
          <SideMenuItem
            key={item.path}
            label={item.name}
            isSelected={item.pathMatch.test(location.pathname)}
            className={isSystemAdminOnlyItem(item) ? 'admin-ui' : undefined}
            onClick={(event) => {
              event?.preventDefault();
              void navigate({ to: item.path });
            }}
          />
        ))}
      </SideMenuGroup>
    </SideMenu>
  );
};
